import React from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Newsletter from './Newsletter';
import { imageSizeTranslation } from '../../utils/image';
import { translate, prefix } from '../../utils/locale';
import { changeCountry } from '../../actions/checkout';
import s from './Footer.scss';


const Footer = ({ properties, setup, footer, navigation, trust, pageType }) => {
	if (properties.siteInitiated === false || properties.siteClosed === true) return null;
	const svgProps = {};
	if (setup.breakPoint === 'mobile') {
		svgProps.stroke = '#0B0B0B';
		svgProps.strokeWidth = '.2';
	}

	return (
		<footer className={[s.footer, s[`footer__${pageType}`]].join(' ')}>
			<div className={s.footer_top}>
				<Link className={s.footer_top_logo} to={prefix(setup, '/')}>
					<img {...imageSizeTranslation('', footer.logo, '-', true, false, 406)} />
				</Link>
				<nav className={s.footer_top_navigation}>
					<div className={s.footer_top_navigation_links}>
						{
							navigation.about && navigation.about.map((link) => {
								const uri = translate(setup, link, 'uri');
								if (/(http|mailto|tel)/.test(uri)) {
									return <a className={s.footer_top_navigation_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
								}
								return <Link className={s.footer_top_navigation_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
							})
						}
					</div>
					<div className={s.footer_top_navigation_links}>
						{
							navigation.assistance && navigation.assistance.map((link) => {
								const uri = translate(setup, link, 'uri');
								if (/(http|mailto|tel)/.test(uri)) {
									return <a className={s.footer_top_navigation_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
								}
								return <Link className={s.footer_top_navigation_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
							})
						}
					</div>
					<div className={s.footer_top_navigation_links}>
						{
							navigation.social && navigation.social.map((link) => {
								const uri = translate(setup, link, 'uri');
								if (/(http|mailto|tel)/.test(uri)) {
									return <a className={s.footer_top_navigation_link} href={uri} key={uri} target="_blank" rel="noopener noreferrer nofollow"><span>{ translate(setup, link, 'title') }</span></a>;
								}
								return <Link className={s.footer_top_navigation_link} to={prefix(setup, uri)} key={uri}><span>{ translate(setup, link, 'title') }</span></Link>;
							})
						}
					</div>
				</nav>
				<div className={s.footer_top_newsletter}>
					<div className={s.footer_top_newsletter_form}>
						<Newsletter />
					</div>
					<div className={s.footer_top_newsletter_trust}>
						{
							trust.icons && (
								<div className={s.footer_top_newsletter_trust_icons}>
									{
										trust.icons.map((trustIcon) => {
											if (trustIcon.restricted && trustIcon.restricted.indexOf(setup.country) === -1) return null;
											return (
												<div key={trustIcon.key} className={s.footer_top_newsletter_trust_icon}>
													<img src={trustIcon.icon.url} alt={trustIcon.icon.alt} />
												</div>
											);
										})
									}
								</div>
							)
						}
					</div>
				</div>
			</div>
			<div className={s.footer_copyright}>{ translate(setup, footer.copyright) }</div>
		</footer>
	);
};

const mapState = ({ environment, pageStatus }) => {
	const { properties, setup, footer, navigation, trust } = environment;
	return { properties, setup, footer, navigation, trust, pageType: pageStatus.pageType };
};

export default connect(mapState, { changeCountry })(Footer);
